exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body img[data-v-ba96c374]{max-width:240px}.icon-pencil[data-v-ba96c374]{position:relative;top:2px;width:14px;margin-left:3px;cursor:pointer}", ""]);

// exports
